const defaultSettings = {
  defaults: {
    ConfigType: "Chord",
    networkProjection: "vertical",
    hoverAnnotation: true,
    highlightAnnotation: false,
    nodeColorConfig: "field",
    nodeColor: "#CCCCCC", 
    nodeRender: "normal", 
    nodeFillOpacity: .35,
    nodeStrokeOpacity: .5,
    nodeSize: 'none', 
    markerMinRadius: 1, 
    markerMaxRadius: 25,
    edgeColorConfig: "source",
    edgeType: "normal",
    edgeRender: "normal",
    edgeFillOpacity: .35,
    edgeStrokeOpacity: .5,
    edgeSize: 'none',
  },
  defaultKeys: [ 
    'ConfigType',
    'networkProjection',
    'hoverAnnotation',
    'highlightAnnotation',
    'nodeColorConfig',
    'nodeColor',
    'nodeRender',
    'nodeFillOpacity',
    'nodeStrokeOpacity',
    'nodeSize',
    'markerMinRadius',
    'markerMaxRadius',
    'edgeColorConfig',
    'edgeType',
    'edgeRender',
    'edgeFillOpacity',
    'edgeStrokeOpacity',
    'edgeSize',

  ]
}

export default defaultSettings;


// WEBPACK FOOTER //
// ./src/components/Configuration/defaultSettings.js